export const ONE_INCH = 25.4
